import type { ReactNode } from 'react'
import { ArrowDownRight, ArrowUpRight } from 'lucide-react'
import { JarvisCard } from './JarvisCard'
import { cn } from '@/lib/cn'

export interface StatCardProps {
  label: string
  value: ReactNode
  delta?: {
    value: string
    direction: 'up' | 'down' | 'flat'
    sentiment: 'good' | 'bad' | 'neutral'
  }
  hint?: string
  icon?: ReactNode
}

export function StatCard({ label, value, delta, hint, icon }: StatCardProps) {
  return (
    <JarvisCard className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-jarvis-muted">{label}</span>
        {icon && <span className="text-jarvis-muted">{icon}</span>}
      </div>
      <div className="text-2xl font-semibold tabular tracking-tight">{value}</div>
      {(delta || hint) && (
        <div className="flex items-center gap-2 text-sm">
          {delta && (
            <span
              className={cn(
                'inline-flex items-center gap-1 tabular',
                delta.sentiment === 'good' && 'text-jarvis-green',
                delta.sentiment === 'bad' && 'text-jarvis-red',
                delta.sentiment === 'neutral' && 'text-jarvis-muted',
              )}
            >
              {delta.direction === 'up' && <ArrowUpRight size={14} />}
              {delta.direction === 'down' && <ArrowDownRight size={14} />}
              {delta.value}
            </span>
          )}
          {hint && <span className="text-jarvis-muted">{hint}</span>}
        </div>
      )}
    </JarvisCard>
  )
}
